import BubbleService from "@/services/Bubble/BubbleService";
import {DEFAULT_UPGRAD_COURSE, UpGradCourse} from "@/lib/types/upgrad/course";

class CourseService extends BubbleService{
    constructor() {
        super();
    }

    getCourses = async () => {
        const data:any = await this.getObjWithoutAuth('Upgrade_Course')
        return data.results
    }

    getCourseTypes = (courses: UpGradCourse[]):string[] => {
        const data = courses.map(course => {
            return course.course_type
        })
        return Array.from(new Set(data))
    }

    getUniversities = (courses: UpGradCourse[]):string[] => {
        const data = courses.map(course => {
            return course.university_name
        })
        return Array.from(new Set(data))
    }

    getCourseTypeOptions = (courses: UpGradCourse[]) =>{
        const data = this.getCourseTypes(courses)
        return data.map(course => {
            return {label:course, value: course}
        })
    }

    getUniversityOptions = (courses: UpGradCourse[]) =>{
        const data = this.getUniversities(courses)
        return data.map(course => {
            return {label:course, value: course}
        })
    }

    getCourse = (courses:UpGradCourse[], courseType:string, university: string):UpGradCourse => {
        const data = courses.find(course => {
            return course.university_name === university && course.course_type === courseType
        })
        return data ?? DEFAULT_UPGRAD_COURSE
    }

}

export default CourseService;